import OrganizationViewModel from "@/domain/OrganizationViewModel";
import ClientBase from "../ClientBase";
import AuthZeroConnectionViewModel from "@/domain/authorization/AuthZeroConnectionViewModel";
import ScanFileStatus from "@/domain/scan/ScanFileStatus";


class AdminClient extends ClientBase {

    async getOrganizationsByTenant(){
        const data = await this.get(`api/v1/dualloadmin/organizations`);
        return data?.map(org => new OrganizationViewModel(org)) ?? [];
    }

    async getConnectionsByTenant(){
        const data = await this.get(`api/v1/dualloadmin/connections`);
        return data?.map(conn => new AuthZeroConnectionViewModel(conn)) ?? [];
    }

    async createOrganization(newOrgRequest){
        const data = await this.post(`api/v1/dualloadmin/organization`, newOrgRequest);
        return data ? new OrganizationViewModel(data) : null;
    }

    async getScanSourceFilePath(organizationId, assetId, scanId){
        return await this.get(`api/v1/dualloadmin/orgs/${organizationId}/assets/${assetId}/scans/${scanId}/source-file`);
    }

    async getProcessedFileUploadSaSLink(orgId, assetId, scanId, videoLength){
        return await this.post(`api/v1/dualloadmin/organizations/${orgId}/assets/${assetId}/scans/${scanId}/sas/processed-file/${videoLength}`);
    }

    async getModelFileUploadSaSLink(orgId, assetId, scanId){
        return await this.post(`api/v1/dualloadmin/organizations/${orgId}/assets/${assetId}/scans/${scanId}/sas/model-file`);
    }

    async getInternalsFileUploadSaSLink(orgId, assetId, scanId){
        return await this.post(`api/v1/dualloadmin/organizations/${orgId}/assets/${assetId}/scans/${scanId}/sas/internals-file`);
    }

    async getExternalsFileUploadSaSLink(orgId, assetId, scanId){
        return await this.post(`api/v1/dualloadmin/organizations/${orgId}/assets/${assetId}/scans/${scanId}/sas/externals-file`);
    }

    async getFramesFileUploadSaSLink(orgId, assetId, scanId, fileNames){
        return await this.post(`api/v1/dualloadmin/organizations/${orgId}/assets/${assetId}/scans/${scanId}/sas/frames`, fileNames);
    }

    async processFramesFiles(orgId, assetId, scanId){
        return await this.post(`api/v1/dualloadmin/organizations/${orgId}/assets/${assetId}/scans/${scanId}/frames/process`);
    }

    async getFileStatus(orgId, assetId, scanId){
        const data = await this.get(`api/v1/dualloadmin/organizations/${orgId}/assets/${assetId}/scans/${scanId}/files/status`);
        return data ? new ScanFileStatus(data) : null;
    }

    async processCameraHelpers(orgId, assetId, scanId){
        return await this.post(`api/v1/dualloadmin/organizations/${orgId}/assets/${assetId}/scans/${scanId}/camerahelpers/process`);
    }

    async setScanProcessingAsComplete(orgId, assetId, scanId){
        return await this.post(`api/v1/dualloadmin/organizations/${orgId}/assets/${assetId}/scans/${scanId}/processing-complete`);
    }

    // Force the scan into a failed state for the given pipeline stage (model-generation | ai-analysis | scan-processing).
    async cancelScan(orgId, assetId, scanId, failureStage, reason){
        return await this.post(`api/v1/dualloadmin/organizations/${orgId}/assets/${assetId}/scans/${scanId}/cancel`, { failureStage, reason });
    }
}

export default new AdminClient();